define('modules/auth/auth.module',["client"],
    function(Prospector){

        Prospector.module("AuthApp", function(AuthApp, Prospector, Backbone, Marionette, $, _){
            AuthApp.startWithParent = false;

            AuthApp.onStart = function(){
                window.utils.rawOutput("starting AuthApp");
            };

            AuthApp.onStop = function(){
                window.utils.rawOutput("stopping AuthApp");
            };
        });

        Prospector.module("Routers.AuthApp", function(AuthAppRouter, Prospector, Backbone, Marionette, $, _){

            AuthAppRouter.Router = Marionette.AppRouter.extend({
                appRoutes: {
                    "login"           : "login"
                    /*"signup"          : "signup",
                    "reset"           : "reset",
                    "authorize"       : "authorize"*/
                }
            });

            var executeAction = function(action, arg){
                Prospector.startSubApp("AuthApp");
                action(arg);
            };

            var API = {
                login: function(criterion){
                    window.session.fetch({
                        success: function(){
                            if (window.session.get('status') == 100) {
                                var func = $.proxy(function(){
                                    if(window.redirectUrl === ""
                                        || window.redirectUrl === "login"
                                        || window.redirectUrl === "dashboard"){
                                        Prospector.trigger('dashboard');
                                    } else {
                                        Prospector.navigate(window.redirectUrl, {trigger: true});
                                    }
                                }, this);
                                Prospector.trigger("authAcc", func);
                            } else {
                                require(["modules/auth/forms/auth.controller"], function(FormsController){
                                    window.utils.raygunTrack('login');
                                    executeAction(FormsController.loadLogin, criterion);
                                });
                            }
                        }
                    });
                },
                /*signup: function(criterion){
                    window.session.fetch({
                        success: function(){
                            if (window.session.get('status') == 100) {
                                var func = $.proxy(function(){
                                    if(window.redirectUrl === ""
                                        || window.redirectUrl.indexOf("login") == 0
                                        || window.redirectUrl.indexOf("dashboard") == 0
                                        || window.redirectUrl.indexOf("signup") == 0
                                        || window.redirectUrl.indexOf("reset") == 0){
                                        Prospector.trigger('dashboard');
                                    } else {
                                        Prospector.navigate(window.redirectUrl, {trigger: true});
                                    }
                                }, this);
                                Prospector.trigger("authAcc", func);
                            } else {
                                require(["modules/auth/signup/signup.controller"], function(SignUpController){
                                    window.utils.raygunTrack('signup');
                                    executeAction(SignUpController.loadSignUp, criterion);
                                });
                            }
                        }
                    });
                },*/
                logout:function(){
                    delete $.ajaxSettings.headers["Authorization"];
                    window.redirectUrl = Prospector.getCurrentRoute();
                    Prospector.trigger("init");
                    Prospector.navigate('login');
                    window.utils.clearStorage(function(){
                        window.location.reload();
                    });
                },
                /*reset:function(criterion){
                    window.session.fetch({
                        success: function(){
                            if (window.session.get('status') == 100) {
                                var func = $.proxy(function(){
                                    if(window.redirectUrl === ""
                                        || window.redirectUrl === "login"
                                        || window.redirectUrl.indexOf("reset") > -1
                                        || window.redirectUrl === "dashboard"){
                                        Prospector.trigger('dashboard');
                                    } else {
                                        Prospector.navigate(window.redirectUrl, {trigger: true});
                                    }
                                }, this);
                                Prospector.trigger("authAcc", func);
                            } else {
                                require(["modules/auth/reset/reset.controller"], function(ResetController){
                                    executeAction(ResetController.loadReset, window.location.hash);
                                });
                            }
                        }
                    });
                },*/
                showCompatability:function(){
                    require(["modules/auth/modals/modals.controller"], function(AuthController) {
                        AuthController.showCompatability();
                    });
                },
                defaultAction:function(){
                },
                /*authorize:function () {
                    var func = $.proxy(function () {
                        require(["modules/auth/oauth/oauth.controller"], function (OAuthController) {
                            window.utils.raygunTrack('authorization');
                            OAuthController.loadAuthorization();
                        });
                    }, this);
                    Prospector.trigger("authAcc", func);
                }*/
            };

            Prospector.on("login", function(){
                API.login();
            });
            Prospector.on('checkUser', function(options){
                var func = function(){
                    try {
                        rg4js('setUser', {
                            identifier: window.user.get('id').toString(),
                            isAnonymous: false,
                            email: window.user.get('id').toString()+"@relpro.com",
                            firstName: window.user.get('id').toString(),
                            fullName: "User# " + window.user.get('id').toString()
                        });
                    }
                    catch(ex){

                    }
                    if (!window.user.get('accepted_terms')) {
                        window.needsReload = true;
                        window.app.trigger("showAcceptedTerms", {passedFunc: options.passedFunc});
                    } else if (window.user.get('mustResetPassword')) {
                        window.needsReload = true;
                        window.app.trigger("mustResetPassword", {passedFunc: options.passedFunc});
                    } else {
                        if(options != undefined && options.passedFunc != undefined){
                            options.passedFunc();
                        } else{
                            window.app.trigger("login");
                        }
                    }
                };
                if(window.user.has('id') && window.user.get('accepted_terms') && !window.user.get('mustResetPassword')){
                    func();
                    window.firstLoad = false;
                } else {
                    window.user.fetch({
                        success: function () {
                            func();
                            window.firstLoad = false;
                        }
                    });
                }
            }, this);
            Prospector.on("sessionDone", function(){
                API.logout();
            });
            Prospector.on("authAcc", function(passedFunc, options){
                if(!window.session.has('status')){
                    window.session.fetch({
                        success: function(){
                            procSession(passedFunc);
                        }
                    });
                } else {
                    procSession(passedFunc);
                }
            });
            var procSession = function(passedFunc){
                window.firstLoad = true;
                if (window.session.get('status') == 100) {
                    if (!window.entitlements.has('id')) {
                        window.entitlements.fetch({success:function() {
                            if(window.entitlements.isValid()){
                                window.contract.fetch({
                                    success: function () {
                                        window.contractQuotas.fetch({
                                            success: function () {
                                                window.app.trigger('checkUser', {
                                                    passedFunc: function () {
                                                      require(["text!modules/auth/forms/templates/auth.template.html",
                                                               "modules/home/main/views/side.menu.view"],
                                                        function (authTemplate, SideMenuView) {
                                                            var temp = _.template(authTemplate);
                                                            $('body').empty();
                                                            $('body').append(temp());
                                                            Prospector.addRegions({
                                                                mainRegion: ".mainUi",
                                                                leftPanel: "#sidebar-wrapper"
                                                            });
                                                            Prospector.trigger("home");
                                                            Prospector.trigger("glueAuthentication");
                                                            if(window.contract.checkIsValid()){
                                                                window.user.following.fetch();
                                                                var sideMenuView = new SideMenuView();
                                                                  /* $('#mainRow').append(sideMenuView.render().el);*/
                                                                sideMenuView.render();
                                                                passedFunc();
                                                                window.firstLoad = false;
                                                            } else {
                                                               Prospector.trigger("lockToAccountInfo"); //lock account
                                                            }
                                                        });
                                                    }
                                                });
                                            }
                                        });
                                    }
                                });
                            }else {
                                window.redirectUrl = Prospector.getCurrentRoute();
                                Prospector.navigate('');
                            }
                        }});
                    } else {
                        $('.subMenu .horizontalIcon').remove();
                        $('.contactName').removeClass('active');
                        if(window.user.has('id')){
                            passedFunc();
                            window.firstLoad = false;
                        } else{
                            window.app.trigger('checkUser', {
                                passedFunc: passedFunc
                            });
                        }
                    }
                    Prospector.trigger("closeTopDrawer");
                } else {
                    window.firstLoad = false;
                    window.redirectUrl = Prospector.getCurrentRoute();
                    Prospector.navigate('login', {trigger: true});
                }
            };

            Prospector.on("showCompatability", function(options) {
                API.showCompatability(options);
            });
            Prospector.on("showMinimal", function(options) {
                require(["text!modules/auth/forms/templates/auth.template.html"],
                        function(authTemplate){
                        var temp = _.template(authTemplate);
                        $('body').empty();
                        $('body').append(temp());
                            $('.canvas').addClass('width100');
                            $('#toggleRow').css("cursor", "pointer");
                            $('#toggleRow').click(function(e) {
                                e.preventDefault();
                            });
                        Prospector.addRegions({
                            mainRegion: ".mainUi",
                            leftPanel: "#sidebar-wrapper",
                            modalRegion: '.modal-dialog'
                        });
                        Prospector.leftPanel.$el.hide();
                        Prospector.mainRegion.$el.empty();
                        if(options != undefined && options.passedFunc != undefined){
                            options.passedFunc();
                        }
                    });
            });

            Prospector.addInitializer(function(){
                // Prospector.trigger("loadCss", "assets/css/auth.css");
                new AuthAppRouter.Router({
                    controller: API
                });
            });
        });

        return Prospector.AuthAppRouter;
    });
